import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';


const pickBy = (value, key) => {
    // console.log('pickBy', value, key, value != null);
    return value != null;
};

export const buildQueryParams = (form: FormGroup, params: any[]): any => {

    const body = [];
    if (form && form.value) {
        body.push(_.pickBy(form.value, function(value, key) {
            return value != null;
        }));
    }
    if (params && params.length) {
        params.forEach((param) => {
            body.push((typeof param === 'object' && !(param instanceof Array))
                ? _.pickBy(param, pickBy)
                : param
            );
        });
    }

    // console.log('buildQueryParams', 'body', body);
    // console.log('buildQueryParams', 'form', form)
    // console.log('buildQueryParams', 'params', params);

    return body;
};

export class LeaResource {
    static methods = {

        save: <T>(url: string, http: HttpClient, form, params = [], options = {}) => {

            console.log('LeaResource', 'save', {url, params: buildQueryParams(form, params), options});
            return http.post<T>(url, buildQueryParams(form, params), options);
        },

        update: <T>(url: string, http: HttpClient, form, params = [], options = {}) => {
            console.log('LeaResource', 'update', {url, params: buildQueryParams(form, params), options});
            return http.patch<T>(url, buildQueryParams(form, params), options);
        },

        find: <T>(url: string, http: HttpClient, form, params = [], options = {}, method = null) => {

            const query = ((method) ? '/'+method : '') + '?params=' 
                + encodeURI(JSON.stringify(buildQueryParams(form, params)));

            console.log('LeaResource', 'find', {url: url + query, options});
            return http.get<T>(url + query, options);
        },

        delete: <T>(url: string, http: HttpClient, params = [], options = {}) => {

            const query = '?params=' 
                + encodeURI(JSON.stringify(buildQueryParams(null, params)));

            console.log('LeaResource', 'delete', {url: url + query, options});
            return http.delete<T>(url + query, options);
        },

        // Generic methods
        get: <T>(url: string, http: HttpClient, methodName, params = [], options = {}) => {
            // console.log({ where: 'get', url, http, methodName, params, options});
            const query = '/' + methodName + '?params=' + 
                encodeURI(JSON.stringify(buildQueryParams(null, params)));

            console.log('LeaResource', 'get', {url: url + query, options});
            return http.get<T>(url + query, options);
        },

        post: <T>(url: string, http: HttpClient, methodName, form, params = [], options = {}) => {

            console.log('LeaResource', 'post', {url, params: buildQueryParams(form, params), options});
            return http.post<T>(url + '/' + methodName, buildQueryParams(form, params), options);
        },

    };
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/resource/lea.resource.ts